module.exports = __webpack_public_path__ + "static/media/test_tube_icon.b846486b.svg";